<template>
    <v-row justify="center">
        <v-dialog v-model="dialogProp" persistent scrollable max-width="500">
            <ValidationObserver ref="obs" >
                <v-card>
                    <v-progress-linear
                        v-if="loading"
                        indeterminate
                        color="primary"
                        rounded
                        height="6"
                    ></v-progress-linear>

                    <v-card-title class="pa-0 shadow-1">
                        <v-img
                            :src="
                                require('@/assets/illustrations/bg_modal_card.svg')
                            "
                            cover
                            position="left bottom"
                            class="align-center"
                            height="65px"
                        >
                            <v-card-title
                                class="font-weight-medium primary--text"
                            >
                                Eliminar {{DialogType.toTitle}}
                            </v-card-title>
                        </v-img>
                    </v-card-title>

                    <vuescroll
                        :ops="{
                            bar: { background: '#bacfcec0', keepShow: true }
                        }"
                    >
                        <v-card-text style="max-height: 350px">
                            <v-form>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-card-title
                                            class="font-weight-medium "
                                        >
                                            Esta seguro que desea eliminar esta
                                            {{DialogType.toTitle}}? 
                                        </v-card-title>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                    </vuescroll>

                    <v-divider></v-divider>

                    <v-card-actions class="mx-2">
                        <v-spacer></v-spacer>
                        <v-hover v-slot:default="{ hover }">
                            <v-btn
                                text
                                rounded
                                class="mr-1"
                                :color="hover ? 'error' : 'grey'"
                                @click="closeDialog"
                                >Cancelar</v-btn
                            >
                        </v-hover>

                        <v-hover v-slot:default="{ hover }">
                            <v-btn
                                rounded
                                :loading="loading"
                                :disabled="loading"
                                color="error"
                                :class="hover ? 'shadow-2' : 'shadow-4'"
                                class="px-8"
                                @click="deleteAction()"
                                >Eliminar</v-btn
                            >
                        </v-hover>
                    </v-card-actions>
                </v-card>
            </ValidationObserver>
        </v-dialog>
    </v-row>
</template>

<script>
import vuescroll from "vuescroll";

const dialogTypes = {
    evaluation: {
        toTitle : "Evaluacion",
        toDispatch: "evaluations/DELETE_EVALUATION"
    },
    evaluationProcess: {
        toTitle: "Proceso",
        toDispatch: "process/DELETE_PROCESS"
    },
    test: {
        toTitle: "Prueba",
        toDispatch: "tests/DELETE_TEST"
    }
}

export default {
    props: {
        mode: {
            type: String,
            default: "evaluation"
        },
        item: {
            type: Object
        },
        dialogProp: {
            type: Boolean,
            default: false
        }
    },
    components: {vuescroll},
    data() {
        return {
            loading: false,
            DialogType: null
        };
    },

    created() {
        this.DialogType = dialogTypes[this.mode]
    },
    methods: {
        closeDialog() {
            this.$emit("dialog:close")
        },
        async deleteAction() {
            this.loading = true
            await this.$store.dispatch(this.DialogType.toDispatch, this.item.id)
            this.closeDialog()
            this.$snotify.success(`${DialogType.toTitle}Pregunta eliminada con exito`, "¡Hecho!")
            this.loading = false
        }
    }
};
</script>
